import { createContentPropTypes } from '../../../helpers/content';

const content = {
	archivedDirectDebitHeader: 'Archived Direct Debit',
	archivedStandingOrderHeader: 'Archived standing order',
	archivedScheduledPaymentHeader: 'Archived scheduled payment',
	archivedBacsCreditHeader: 'Archived Bacs Credit',
	archivedBacsDebitHeader: 'Archived Bacs Debit',
	archivedIFTPaymentHeader: 'Archived International Payment',
	archivedCHAPSPaymentHeader: 'Archived CHAPS Payment',
	closeLabel: 'Close',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
